import { useState } from "react";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import "./User-Profile-Comp.css";
import { UserTransactionsList } from "./UserTransactionsListComp";

export const UserTransactionsWrapper = () => {
  const [payLoadFilter, setpayLoadFilter] = useState<any>({});
  const [externalFilter, setExternalFilter] = useState<any>({});

  const authData: any = useAppSelector((state: RootState) => state);

  // Use to collect Change
  const handleInputChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    // console.log(value)
    setpayLoadFilter((values) => ({ ...values, [name]: value }));
    if (name === "status") {
      setExternalFilter({ ...externalFilter, status: value });
    }
  };

  const handleButtonClick = (value) => {
    setpayLoadFilter((values) => ({ ...values }));
  };

  // Use to Update Filter
  const updateFilter = () => {
    setExternalFilter({ ...payLoadFilter });
  };

  return (
    <>
      <div className="grid p-4">
        {/* Filters */}
        <div className="flex flex-row mt-6 gap-2">
          <div className="basis-10/12">
            <div>
              <input
                name="searchstring"
                value={payLoadFilter?.searchstring || ""}
                onChange={handleInputChange}
                onBlur={updateFilter}
                className="h-12 w-full border dark:border-stone-600 rounded-xl p-2 bg-white dark:bg-stone-700 text-gray-900 dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
                placeholder="Search"
              />
            </div>
          </div>

          <div className="basis-2/12">
            <div>
              <button className="h-12 w-full border rounded-xl p-2 border-blue-800 dark:border-blue-400 text-blue-800 dark:text-blue-400 hover:bg-blue-500/[0.05] dark:hover:bg-blue-400/[0.1]">
                Search
              </button>
            </div>
          </div>
        </div>

        {/* Table/List/Grid */}
        <div className="grid mt-4">
          <UserTransactionsList></UserTransactionsList>
        </div>
      </div>
    </>
  );
};

export default UserTransactionsWrapper;
